<template>
  <div class="portals">
    <SeviceApply />
    <AddGoodsPop />
    <BindSaasPop />
    <ChooseMediaPop />
    <WithdrawPop />
    <WithdrawGuidePop />
    <ChangeBindPhonePop />
    <NicknamePop />
    <AddAccountPop />
  </div>
</template>
<script>
import {
  SeviceApply,
  BindSaasPop,
  AddGoodsPop,
  ChooseMediaPop,
  WithdrawPop,
  WithdrawGuidePop,
  ChangeBindPhonePop,
  NicknamePop,
  AddAccountPop,
} from '@/components/modals';

export default {
  name: 'Portals',
  components: {
    SeviceApply,
    BindSaasPop,
    AddGoodsPop,
    ChooseMediaPop,
    WithdrawPop,
    WithdrawGuidePop,
    ChangeBindPhonePop,
    NicknamePop,
    AddAccountPop,
  },
};
</script>

